import { render, staticRenderFns } from "./SImageRadioEditor.vue?vue&type=template&id=0cc81b36&"
import script from "./SImageRadioEditor.vue?vue&type=script&lang=js&"
export * from "./SImageRadioEditor.vue?vue&type=script&lang=js&"
import style0 from "./SImageRadioEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports